import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Build-Time-Konfig-Check: wenn REACT_APP_BACKEND_URL beim Build leer war,
// landet "undefined/api/..." in den Webhook-URLs auf der Settings-Seite.
// Lieber laut beim Boot scheitern als später ne kaputte URL kopieren.
if (!process.env.REACT_APP_BACKEND_URL) {
  // eslint-disable-next-line no-console
  console.error(
    "FATAL: REACT_APP_BACKEND_URL ist nicht gesetzt. " +
      "Build muss mit gesetztem Env-Var laufen (siehe frontend/.env.production.local)."
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
